var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoDaniel(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 179,
    height: 48,
    viewBox: "0 0 179 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M104.392 46.8356L95.0538 35.9654V10.265H90.7014V30.9029L64.1275 -0.00744629L62.7836 1.15723L71.5115 11.3132V37.7124H75.9527V16.4921L103.048 48.0042L104.392 46.8356ZM164.568 10.2727V33.7176H179.008V37.7318H160.123V10.2727H164.568ZM147.468 37.7318H127.258V10.2727H147.472V14.5121H131.7V22.1019H146.8V26.12H131.7V33.4963H147.468V37.7318ZM109.046 10.2727H113.487V37.7318H109.046V10.2727ZM46.4438 14.8615L40.6741 27.9253H52.2135L46.4438 14.8615ZM53.8085 31.9434H39.0366L36.4646 37.7473H31.8303L44.0687 10.2883H48.8227L61.0612 37.7473H56.4269L53.8085 31.9434ZM4.44156 33.4963H10.416C17.0816 33.4963 19.8892 28.5736 19.7734 23.7519C19.6537 19.1281 16.8461 14.516 10.416 14.516H4.44929L4.44156 33.4963ZM10.416 10.2766C19.7348 10.2766 23.9829 16.9929 24.0987 23.7713C24.2532 30.7088 19.9665 37.7473 10.416 37.7473H-0.0112305V10.2727L10.416 10.2766Z",
    fill: "#22272D"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoDaniel);
export default __webpack_public_path__ + "static/media/logo-daniel.8c69cd4e.svg";
export { ForwardRef as ReactComponent };